export const rootPath = 'https://caselaw.vn'

export interface MenuItem {
  href: string
  label: string
}

export const headerMenu: MenuItem[] = [
  {
    href: `${rootPath}/van-ban-phap-luat`,
    label: 'Văn Bản Pháp Luật',
  },
  {
    href: `${rootPath}/ban-an`,
    label: 'Bản Án',
  },
  {
    href: `${rootPath}/hop-dong-mau`,
    label: 'Hợp Đồng Mẫu',
  },
  {
    href: `${rootPath}/ket-qua-tra-cuu-ma-hs`,
    label: 'Tra Cứu Mã HS',
  },
  {
    href: `${rootPath}/cong-cu`,
    label: 'Công Cụ',
  },
  {
    href: `${rootPath}/bai-viet`,
    label: 'Bài Viết',
  },
]
